export function setTableHeight(isDataAvailable) {
  return isDataAvailable
    ? "h-[calc(100vh-8em)] 2xs:max-lg:h-[calc(100vh-7em)] 2xs:max-md:h-[calc(100vh-9em)]"
    : "h-[calc(100vh-5em)] 2xs:max-lg:h-[calc(100vh-4em)] 2xs:max-md:h-[calc(100vh-6em)] md:mt-3";
}
